import { BUTTON_G_FIELD } from '../type_name'
import { VBtn } from 'vuetify/lib'
const default_key = {
    depressed: true,
    small: true
}
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'center'
    return header_clone
}
export default {
    name: BUTTON_G_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        },
        index: {
            type: Number,
        },
        target: {
            type: Object,
        }
    },
    computed: {
        valueHandle() {
            let { buttons } = this.header 
            if (buttons instanceof Function) {
                buttons = buttons({header:this.header, target:this.target})
            }
            return buttons.map(item => {
                const { text, callback, _text, style = {}, ...other } = (item || {})
                const style_c = {
                    margin: '0px 5px',
                    ...style
                }
                return <VBtn
                 style={style_c}
                 props={{
                    ...default_key,
                    ...other,
                    text:!!_text,
                }}
                on-click={() => {
                    callback && callback(this.target, this.header, this.index)
                }}
                >{text}</VBtn>
            })
        }
    },
    methods: {

    },
    render() {
        return <div>
            {this.valueHandle}
        </div> 
    }
}